<template>
  <component
    :is="dynamicComponent"
    ref="stickyMenu"
    :isActive="isActive"
    :isHeaderFixed="isHeaderFixed"
    @mounted="$emit('mounted')"
  >
    <slot />
  </component>
</template>

<script>
import { isPositionStickySupported } from '@/helpers/browser-support'
import PositionSticky from './PositionSticky.vue'
import PositionFixedOrAbsolute from './PositionFixedOrAbsolute.vue'
import props from './sticky-menu-props'

const DYNAMIC_COMPONENT_DEFAULT = 'div'
const COMPONENTS = {
  positionSticky: () => PositionSticky,
  positionFixedOrAbsolute: () => PositionFixedOrAbsolute,
}
const supportsPositionSticky = isPositionStickySupported()

export function preloadStickyMenuComponent() {
  COMPONENTS.positionSticky()
}

export default {
  name: 'StickyMenu',

  components: {
    PositionSticky,
    PositionFixedOrAbsolute,
  },

  props,

  data() {
    return {
      dynamicComponent: DYNAMIC_COMPONENT_DEFAULT,
      supportsPositionSticky: isPositionStickySupported(),
    }
  },

  computed: {
    isPositionSticky() {
      return this.dynamicComponent !== DYNAMIC_COMPONENT_DEFAULT
    },
  },

  watch: {
    isActive: {
      immediate: true,
      handler() {
        // TODO: https://app.asana.com/0/1199913855170360/1200041494905015/f
        // PositionFixedOrAbsolute is currently broken when menu is taller than gallery
        if (this.isActive && supportsPositionSticky) this.dynamicComponent = PositionSticky
      },
    },
  },

  mounted() {
    if (!this.isPositionSticky) this.$emit('mounted')
  },

  methods: {
    getInstance() {
      if (this.isPositionSticky) return this.$refs?.stickyMenu
    },

    scrollToTop() {
      if (this.isPositionSticky) this.$refs?.stickyMenu?.scrollToTop()
    },

    beforeHeightChange(additionalHeight, disablesScroll) {
      if (this.isPositionSticky)
        this.$refs?.stickyMenu?.beforeHeightChange(additionalHeight, disablesScroll)
    },

    afterHeightChange() {
      if (this.isPositionSticky) this.$refs?.stickyMenu?.afterHeightChange()
    },
  },
}
</script>
